<template>
	<div class="text-center" v-if="changeResponsablePromptModal">
		<v-dialog
			:value="changeResponsablePromptModal"
			max-width="520"
			scrollable
			persistent
		>
			<v-card>
				<v-card-text class="pa-0">
					<div class="py-4 px-8">
						<div class="d-flex flex-row align-center justify-space-between">
							<p class="mb-0 font-weight-bold text-primary title">Cambio de Responsable</p>
							<v-btn
								class="mx-2"
								fab
								dark
								small
								color="#F4516C"
								@click="closeModal && closeModal()"
							>
								<v-icon dark>mdi-close</v-icon>
							</v-btn>
						</div>
						<v-row align="center" class="my-2">
							<v-col cols="12">
								<p class="mb-0 text-primary">
									¿Deseas mantener a <b>{{ previousResponsableName }}</b> como participante al asignar a
									<b>{{ nextResponsableName }}</b> como nuevo responsable?
								</p>
							</v-col>
						</v-row>
						<v-row align="center">
							<v-col cols="12">
								<div class="change-responsable-actions">
									<v-btn
										class="action-btn text-none"
										rounded
										color="#5E85EF"
										raised
										dark
										:loading="loading"
										@click="onlyChange && onlyChange()"
									>
										<span class="action-label">Sólo cambiar</span>
									</v-btn>
									<v-btn
										class="action-btn text-none"
										rounded
										color="#2D4B95"
										raised
										dark
										:loading="loading"
										@click="keepParticipant && keepParticipant()"
									>
										<span class="action-label">Mantener participante</span>
									</v-btn>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'ChangeResponsablePromptModal',
	props: {
		changeResponsablePromptModal: {
			type: Boolean,
			default: false
		},
		previousResponsableName: {
			type: String,
			default: 'responsable actual'
		},
		nextResponsableName: {
			type: String,
			default: 'nuevo responsable'
		},
		loading: {
			type: Boolean,
			default: false
		},
		closeModal: {
			type: Function,
			required: true
		},
		onlyChange: {
			type: Function,
			required: true
		},
		keepParticipant: {
			type: Function,
			required: true
		},
	}
};
</script>

<style scoped>
.text-primary{
	color: #2D4B95;
}
.change-responsable-actions{
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
}
.action-btn{
	flex: 1 1 0;
	min-width: 0 !important;
	min-height: 48px !important;
	margin: 0 !important;
}
/deep/ .action-btn .v-btn__content{
	white-space: normal;
	text-align: center;
	letter-spacing: 0.3px;
}
.action-label{
	display: block;
	font-size: 16px;
	line-height: 1.2;
}
@media (max-width: 600px){
	.change-responsable-actions{
		flex-direction: column;
	}
	.action-btn{
		width: 100%;
	}
	.action-label{
		font-size: 15px;
	}
}
</style>
